import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=05408d1e&scoped=true"
import script from "./Blogs.vue?vue&type=script&lang=ts"
export * from "./Blogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05408d1e",
  null
  
)

export default component.exports